import { render, staticRenderFns } from "./ReviewActions.vue?vue&type=template&id=1c328ea6&scoped=true&"
import script from "./ReviewActions.vue?vue&type=script&lang=ts&"
export * from "./ReviewActions.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewActions.vue?vue&type=style&index=0&id=1c328ea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c328ea6",
  null
  
)

export default component.exports